import React from 'react';
import Page from '../../components/Page';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress
} from '@mui/material';
import StaffDetails from '../../sections/staff/StaffDetails';
import { useStaff } from '../Staff';
import { useManager } from '../Manager';

const StaffData = ({ manager }) => {
  const { application } = manager ? useManager() : useStaff();

  return (
    <Page title="Twoje Dane">
      <Card width="100%">
        <CardHeader title="Twoje dane" />
        <CardContent>
          {!application ? (
            <Box width={500} height={300}>
              <CircularProgress />
            </Box>
          ) : (
            <StaffDetails manager={manager} />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default StaffData;
